import React from 'react';
import { Grid } from '@material-ui/core';
import { CORP_BLUE, FONT_SIZE_UPLOAD } from 'config/config';
import { FileUpload } from '@mui/icons-material';
import { DeleteForeverOutlined } from '@material-ui/icons';

const UploadComponent = props => {
  const { classes, titulo, changeSingleFile, deleteSingleFile, files } = props;

  return (
    <Grid container>
      <Grid container alignItems="center" key={'0A'}>
        <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
        <Grid item xs={10}>
          <p style={{ fontSize: FONT_SIZE_UPLOAD }}>{titulo}</p>
        </Grid>
        <Grid item xs={2} container justifyContent="center">
          <Grid item xs={3}>
            <input
              accept=".pdf"
              className={classes.input}
              id={'contained-button-file-input'}
              type="file"
              onChange={e => changeSingleFile(e)}
              hidden
            />
            <label htmlFor={'contained-button-file-input'}>
              <FileUpload style={{ color: 'green', marginTop: 5, fontSize: 40 }} />
            </label>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
      {files.length === 0
        ? null
        : files.map((item, index) => {
            return (
              <Grid container key={index}>
                <Grid container>
                  <Grid item xs={10} container alignItems="center" style={{ fontSize: FONT_SIZE_UPLOAD }}>
                    {item.file.name}
                  </Grid>
                  <Grid item xs={2} container justifyContent="flex-end">
                    <DeleteForeverOutlined
                      onClick={e => deleteSingleFile(index)}
                      style={{
                        color: 'red',
                        marginTop: 5,
                        marginBottom: 5,
                        fontSize: 40,
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
                </Grid>
              </Grid>
            );
          })}
    </Grid>
  );
};

export default UploadComponent;
